export default {
  cancelAddOnText: (addOnName: string): string =>
    `Are you sure you want to remove ${addOnName} from your subscription starting on your next billing cycle? You will lose any promotional pricing you may have had for this add-on if you choose to reactivate it later. You will continue to have ${addOnName} until your next billing cycle begins.`,
  customerSupportDescriptor: "Have other billing or account questions?",
  mgmPromoLinkText: "Think you may be eligible for a Bet MGM promotion?"
};
